// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/table_bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.feedback-table {
  border-radius: 5px;
  padding: 10px;
  height: 90vh;
  overflow: auto;
  width: 85vw;
  font-size: 11px;
  border: none;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat left center;
  max-width: none;
}

.table-container {
  overflow-x: auto;
}

.table-container table {
  width: 100%;
  border-collapse: separate; /* Use separate borders to manage individually */
  border-spacing: 0; /* Remove extra spacing between cells */
}

.table-container th,
.table-container td {
  padding: 12px 15px;
  text-align: left;
}

.table-container th {
  background-color: #f0f0f0;
  vertical-align: middle;
}

.table-container tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.action-icon {
  cursor: pointer;
  margin-right: 10px; 
  font-size: 1.5rem;
  background-color: white;
  border: 1px lightgrey solid;
  border-radius: 5px;
  padding: 1px;
}


.pagination {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.feedback-table-wrapper {
  background-color: white;
  height: 92vh;
  width: 100%;
}

.custom-date-input {
  display: flex;
  align-items: center;
  gap: 5px;
}

.calendar-icon {
  background-color: whitesmoke;
  border: 1px lightgray solid;
  border-radius: 3px;
}

.global-feedback-search {
  width: auto;
  font-size: 13px;
  box-sizing: border-box;
}

.custom-button {
  color: #496c58;
  border-color: #496c58;
  font-size: 13px;
  font-weight: bold;
  white-space: nowrap; /* Prevent text wrapping */
  display: flex;
  align-items: center; /* Vertically center the text */
}

.custom-button:hover,
.custom-button:focus,
.custom-button:active {
  color: #496c58;
  border-color: #496c58;
  background-color: transparent;
  box-shadow: none;
}

.header-and-search-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.custom-button-link {
  text-decoration: none;
  color: #496c58;
}

@media (max-width: 768px) {
  .header-and-search-container {
    flex-direction: column;
    align-items: stretch;
  }

  .global-feedback-search,
  .custom-button {
    width: 100%;
    height: 40px; /* Ensure same height for input and button */
    margin-bottom: 10px;
  }

  .custom-button {
    justify-content: center;
  }
  .pagination {
    flex-direction: column;
  }
}

@media (max-width: 480px) {
  .global-feedback-search {
    font-size: 11px; /* Adjust font size for very small screens */
  }

  .custom-button {
    font-size: 11px;
    height: 40px; /* Ensure same height as the input */
  }

  .pagination {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/FeedbackTable/FeedbackTable.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,yEAAkE;EAClE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB,EAAE,gDAAgD;EAC3E,iBAAiB,EAAE,uCAAuC;AAC5D;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,YAAY;AACd;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,mBAAmB,EAAE,0BAA0B;EAC/C,aAAa;EACb,mBAAmB,EAAE,+BAA+B;AACtD;;AAEA;;;EAGE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;IACX,YAAY,EAAE,4CAA4C;IAC1D,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,eAAe,EAAE,4CAA4C;EAC/D;;EAEA;IACE,eAAe;IACf,YAAY,EAAE,oCAAoC;EACpD;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".feedback-table {\r\n  border-radius: 5px;\r\n  padding: 10px;\r\n  height: 90vh;\r\n  overflow: auto;\r\n  width: 85vw;\r\n  font-size: 11px;\r\n  border: none;\r\n  background: url(\"../../Assets/table_bg.jpg\") no-repeat left center;\r\n  max-width: none;\r\n}\r\n\r\n.table-container {\r\n  overflow-x: auto;\r\n}\r\n\r\n.table-container table {\r\n  width: 100%;\r\n  border-collapse: separate; /* Use separate borders to manage individually */\r\n  border-spacing: 0; /* Remove extra spacing between cells */\r\n}\r\n\r\n.table-container th,\r\n.table-container td {\r\n  padding: 12px 15px;\r\n  text-align: left;\r\n}\r\n\r\n.table-container th {\r\n  background-color: #f0f0f0;\r\n  vertical-align: middle;\r\n}\r\n\r\n.table-container tbody tr:nth-child(even) {\r\n  background-color: #f9f9f9;\r\n}\r\n\r\n.action-icon {\r\n  cursor: pointer;\r\n  margin-right: 10px; \r\n  font-size: 1.5rem;\r\n  background-color: white;\r\n  border: 1px lightgrey solid;\r\n  border-radius: 5px;\r\n  padding: 1px;\r\n}\r\n\r\n\r\n.pagination {\r\n  display: flex;\r\n  gap: 10px;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.feedback-table-wrapper {\r\n  background-color: white;\r\n  height: 92vh;\r\n  width: 100%;\r\n}\r\n\r\n.custom-date-input {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n\r\n.calendar-icon {\r\n  background-color: whitesmoke;\r\n  border: 1px lightgray solid;\r\n  border-radius: 3px;\r\n}\r\n\r\n.global-feedback-search {\r\n  width: auto;\r\n  font-size: 13px;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.custom-button {\r\n  color: #496c58;\r\n  border-color: #496c58;\r\n  font-size: 13px;\r\n  font-weight: bold;\r\n  white-space: nowrap; /* Prevent text wrapping */\r\n  display: flex;\r\n  align-items: center; /* Vertically center the text */\r\n}\r\n\r\n.custom-button:hover,\r\n.custom-button:focus,\r\n.custom-button:active {\r\n  color: #496c58;\r\n  border-color: #496c58;\r\n  background-color: transparent;\r\n  box-shadow: none;\r\n}\r\n\r\n.header-and-search-container {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 100%;\r\n}\r\n\r\n.custom-button-link {\r\n  text-decoration: none;\r\n  color: #496c58;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .header-and-search-container {\r\n    flex-direction: column;\r\n    align-items: stretch;\r\n  }\r\n\r\n  .global-feedback-search,\r\n  .custom-button {\r\n    width: 100%;\r\n    height: 40px; /* Ensure same height for input and button */\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .custom-button {\r\n    justify-content: center;\r\n  }\r\n  .pagination {\r\n    flex-direction: column;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .global-feedback-search {\r\n    font-size: 11px; /* Adjust font size for very small screens */\r\n  }\r\n\r\n  .custom-button {\r\n    font-size: 11px;\r\n    height: 40px; /* Ensure same height as the input */\r\n  }\r\n\r\n  .pagination {\r\n    flex-direction: column;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
